import { graphql } from '@/generated/gql';

export const DEMAND_CASES_COUNT_QUERY = graphql(/* GraphQL */ `
  query DemandCasesCount($id: UUID!) {
    tesseract {
      demand(id: $id) {
        id
        negotiationCases {
          totalCount
          nodes {
            id
            isReleasable
          }
        }
      }
    }
  }
`);
